<template>
  <q-page padding >
    <div class="text-center"><h4 style="margin: 0">Enquiry</h4></div>
      <q-card style="margin: 20px 0; padding: 30px">
        <q-card-section>
          <div class="row" style="margin: 0 0 20px 0">
            <div class="col-sm-12 col-md-4 col-lg-3">
              <p class="text-bold text-h6 ">Customer Details:</p>
              <p><b>Name: </b> {{enquiry.firstName}}</p>
              <p><b>Lastname: </b> {{enquiry.lastName}}</p>
              <p><b>email: </b> {{enquiry.email}}</p>
              <p><b>phone: </b> {{enquiry.phone}}</p>
            </div>
            <q-separator spaced inset vertical style="margin: 0 40px"/>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <p class="text-bold text-h6 ">Enquiry Details:</p>
              <p><b>Type:</b> {{enquiry.type}}</p>
              <p><b>Timezone:</b> {{enquiry.timezone}}</p>
              <p><b>Source:</b> {{enquiry.utm_source}}</p>
              <p><b>Medium:</b> {{enquiry.utm_medium}}</p>
              <p><b>Campaign:</b> {{enquiry.utm_campaign}}</p>
              <p><b>Territory:</b> {{enquiry.territory}}</p>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <p class="text-bold text-h6 ">Message:</p>
          <q-card style="min-height: 400px; margin: 0px 20px">
            <q-card-section>
              {{enquiry.message}}
            </q-card-section>
          </q-card>
          
        </q-card-section>        
        <q-card-section>
          <q-btn color="black" label="Mark as Unread" @click="onClick" style="margin:5px"/>
          <q-btn color="primary" label="Delete" @click="onClick" style="margin:5px"/>
        </q-card-section>
      </q-card>
  </q-page>
</template>

<script>
/* eslint-disable */
import gql from 'graphql-tag'
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'Enquiry',
  apollo: {
    enquiry () {
      return {
        query: gql`query enquiry($id:ID!) {
            enquiry(id:$id) {
              id
              firstName
              lastName
              message
              email
              phone
              type
              timezone
              utm_source
              utm_medium
              utm_campaign
              territory
              eid
              notes
              updatedAt
              createdAt
            }
        }`,
        variables:{
          id: this.$route.params.id
        },
        fetchPolicy: 'network-only',
        async result ({ data }) { 
          console.log('d',data); 
        }
      }
    }
  },
  data (){
    return {

    }
  },
  methods: {
    moment
  }
}
</script>


<style scoped>
 .my-card {
     width:400px;
     height:200px;
}
</style>